<div class="flex-column g-space-sm">
  <cam-title [level]="4" [isBold]="true">{{ this.titleKey() | translate }}</cam-title>

  <div class="user-container g-space-sm">
    @if (this.user().firstName && this.user().lastName) {
      <cam-user-logo class="align-center" [size]="'xxl'" [user]="this.getUserLogoData(this.user())"></cam-user-logo>
    }

    <div>
      @if (this.user().lastName || this.user().firstName) {
        <cam-item-display [label]="'user.user-profile.full-name'">
          {{
            this.fullName({
              firstName: this.user().firstName ?? '',
              name: this.user().lastName ?? '',
            })
          }}
        </cam-item-display>
      }
      @if (this.user().phoneNumber || this.user().userName) {
        <div class="info-grid">
          <cam-item-display [label]="'user.user-profile.phone'">
            @if (this.user().phoneNumber) {
              <cam-link [underline]="false" icon="phone" [size]="'sm'">{{ this.user().phoneNumber }}</cam-link>
            } @else {
              {{ 'user.user-profile.not-available' | translate }}
            }
          </cam-item-display>
          <cam-item-display [label]="'user.user-profile.email'">
            @if (this.user().phoneNumber) {
              <cam-link [underline]="false" icon="mail" [size]="'sm'">{{ this.user().userName }}</cam-link>
            } @else {
              {{ 'user.user-profile.not-available' | translate }}
            }
          </cam-item-display>
        </div>
      }
    </div>
  </div>
</div>
